import { render } from "./YoutubeCont.vue?vue&type=template&id=445ccfa2&scoped=true"
import script from "./YoutubeCont.vue?vue&type=script&lang=js"
export * from "./YoutubeCont.vue?vue&type=script&lang=js"

import "./YoutubeCont.vue?vue&type=style&index=0&id=445ccfa2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445ccfa2"]])

export default __exports__